import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  const data = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 10px;\n    right: 10px;\n    bottom: 10px;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n    overflow: hidden;\n    position: relative;\n    margin: 2em auto;\n    padding: 0 0.5em 0.5em 0.5em;\n    display: flex;\n    align-items: flex-end;\n    background-color: #20242b;\n    border-radius: 0.5em;\n    color: #f0f8ff;\n    line-height: 1.6em;\n\n    &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 2em;\n        background-image: linear-gradient(\n            to top,\n            transparent 0%,\n            #20242b 70%,\n            #20242b 100%\n        );\n    }\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n    font-family: 'Source Code Pro', monospace;\n    font-size: 16px;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { SubSteps } from '../SubSteps';
export const Console = ({
  scale = 1,
  width = 600,
  height = 300,
  start,
  unwrap,
  children
}) => {
  return React.createElement(SubSteps, {
    start: start,
    unwrap: unwrap
  }, React.createElement(Wrapper, null, React.createElement(Container, {
    style: {
      fontSize: "".concat(scale, "em"),
      width,
      height
    }
  }, React.createElement("div", null, children))));
};
const Wrapper = styled.div(_templateObject());
const Container = styled.div(_templateObject2());
const Scroll = styled.div(_templateObject3());